import IMProviders from './IMProviders';

export default IMProviders;
